'use strict';

import coordinator from './presentation/coordinator.mjs';

coordinator.coordinate();
